import type { Release } from '../releases.ts';

export default {
  version: '0.7.0',
  date: '2026-09-29',
  title: 'Workflows, search and monitoring',
  summary: [
    'Workflows on an asset or a sequence, with an EDL export step',
    'Timecode-based metadata layers with a Log tab',
    'System status for administrators',
    'Integration API keys and an API reference',
    'Advanced search and personal collections',
    'Ingest and export monitoring for everyone',
  ],
  features: [
    'Workflows started on an asset or a sequence, with an EDL export step',
    'Timecode-based metadata layers with a Log tab',
    'System status for administrators: services, workers, logs, jobs and storage',
    'Integration API keys and an OpenAPI reference',
    'Advanced search in chosen fields with conditions',
    'Model editor: timecode layers, hidden fields',
    'Personal collections',
    'Ingest and export monitoring for everyone',
  ],
  fixes: [],
} satisfies Release;
